// Kullanıcı bazlı prim ciro girişleri CRUD mutation'ları.
// useDynamicEntity pattern'ine uygun: object/_set/id parametre adlandırması.

export const CREATE_USER_REVENUE_ENTRY_MUTATION = `
  mutation CreateUserRevenueEntry($object: user_revenue_entries_insert_input!) {
    insert_user_revenue_entries_one(object: $object) {
      id
      user_id
      company_id
      yil
      ceyrek
      ciro_kanali
      bonus_revenue_type_id
      firm_id
      contract_id
      job_id
      tutar
      ay_sayisi
      secili_aylar
      is_manual_amount
      toplam_ay
      aciklama
    }
  }
`;

export const UPDATE_USER_REVENUE_ENTRY_MUTATION = `
  mutation UpdateUserRevenueEntry($id: Int!, $_set: user_revenue_entries_set_input!) {
    update_user_revenue_entries_by_pk(pk_columns: { id: $id }, _set: $_set) {
      id
      yil
      ceyrek
      ciro_kanali
      bonus_revenue_type_id
      firm_id
      contract_id
      job_id
      tutar
      ay_sayisi
      secili_aylar
      is_manual_amount
      toplam_ay
      aciklama
    }
  }
`;

export const DELETE_USER_REVENUE_ENTRY_MUTATION = `
  mutation DeleteUserRevenueEntry($id: Int!) {
    delete_user_revenue_entries_by_pk(id: $id) {
      id
    }
  }
`;

// ROOT-only status onayı/reddi. `rejectReason` opsiyonel; APPROVED'da null
// pas geç, REJECTED'da neden ile.
export const UPDATE_USER_REVENUE_ENTRY_STATUS_MUTATION = `
  mutation UpdateUserRevenueEntryStatus(
    $id: Int!
    $status: String!
    $rejectReason: String
  ) {
    update_user_revenue_entries_by_pk(
      pk_columns: { id: $id }
      _set: { status: $status, reject_reason: $rejectReason }
    ) {
      id
      status
      reject_reason
    }
  }
`;
